export default __webpack_public_path__ + "static/media/crossfire.9bf16014.jpg";